import React, { Component } from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import editPencil from "../../assets/images/edit-icon.png";
import { connect } from "react-redux";
import { ALT_THUMBNAIL, API_LIMIT, MODULE_ID_MAP, START_PAGE, contentMaster, isModuleExist } from "../../utils/Constant";

import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { CATEGORY_VERIFY, PERSONALIZATION_CATEGORY_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import PersonalizationCategoryForm from "./PersonalizationCategoryForm";
import { deletePersonalizationCategoryApi, getPersonalizationCategoryApi } from "./Api";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";

export class PersonalizationCategory extends Component {
    constructor(props) {

        super(props);
        const AccesData = isModuleExist(MODULE_ID_MAP.PersonalizationCategory);
        this.state = {
            access: AccesData,
            dummyData: [],
            pageSize: API_LIMIT,
            currentPage: START_PAGE,
            languageList: [],
            totalPages: null,
            delete: false,
            deleteData: {},
            editData: "",
            showEdit: false,

            isVerify: false,
            show: false,

            verified: '',
            verifyUrl: ''
        };
    }
    // todo---------------------------------------
    componentDidMount() {
        const { history } = this.props;
        history({
            pathname: this.props.location.pathname,
            search: `?p=${this.state.currentPage || START_PAGE}`,
        });
        this.props.getPersonalizationCategoryApi(this);
    }
    // todo---------------------------------------
    // todo:-----------------------------------------
    componentDidUpdate(prevProps, prevState) {
        const prevParams = new URLSearchParams(prevProps.location.search);
        const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
        const prevVerified = prevParams.get("isVerified") || "";
        const prevSearch = prevParams.get("search") || "";
        const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;

        const params = new URLSearchParams(this.props.location.search);
        const page = parseInt(params.get("page"), 10) || START_PAGE;
        const verified = params.get("isVerified") || "";
        const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;

        if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {

            this.setState({ currentPage: page }, () => {
                this.props.getPersonalizationCategoryApi(this);

            });
        }
    }
    // todo:-----------------------------------------

    showEditModal = (rowData = null) => {
        this.setState({
            showEdit: !this.state.showEdit,
            editData: rowData,
        });
    };
    openCloseDeleteModal = (rowData) => {
        this.setState({
            delete: !this.state.delete,
            deleteData: rowData,
        });
    };
    deleteHandle = (id) => {
        deletePersonalizationCategoryApi(id, this, this.openCloseDeleteModal)
    }
    render() {
        const { showEdit, access } = this.state;
        const { categoryList, totalPages, currentPage } = this.props.personalizationState;
        return (
            <section className="request-section">

                {this.state.delete && (
                    <InformationModal
                        show={this.state.delete}
                        id={this.state.deleteData.uuid}
                        title={`Are you sure you want to delete ${this.state.deleteData.categoryName} category?`}
                        handleClose={this.openCloseDeleteModal}
                        handleDelete={this.deleteHandle}

                    />
                )}
                {
                    showEdit &&
                    <PersonalizationCategoryForm
                        show={showEdit}
                        onHide={this.showEditModal}
                        editData={this.state.editData}
                        this={this}
                    />
                }
                <VerifiedModal
                    name={`'${this.state.editData?.categoryName}'`}
                    show={this.state.show}
                    url={PERSONALIZATION_CATEGORY_VERIFY + `/${this.state?.editData?.uuid}`}
                    isVerified={this.state.isVerify}
                    handleCancel={() => { this.setState({ show: false }) }}
                    successRes={() => { this.props.getPersonalizationCategoryApi(this); }}
                />
                <ComponentHeader
                    title="Personalization Category"
                    breadcrumb={[["Personalization", ""], ["Category", ""]]}
                    primaryBtn={access.createAccess ? "Add Category " : ""}
                    handlePrimaryBtn={() => {
                        this.setState({ showEdit: true })
                    }}
                    ctx={this}
                />
                <Row>
                    <Col sm={2}>
                        <FilterVefiedDropDown ctx={this} />
                    </Col>
                </Row>
                <div className="commom-table-wrapper">

                    <CustomTable
                        ctx={this}
                        data={categoryList?.list || []}
                        columns={[
                            {
                                width: 250,
                                title: "Name",
                                dataIndex: "categoryName",
                                className: "name",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return rowData.categoryName;
                                },
                            },
                            {
                                width: access.verificationAccess ? 100 : 0,
                                title: "Verified",
                                dataIndex: "isVerified",
                                className: "name",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    const color = rowData.isVerified ? 'green' : 'orange';
                                    return <div className=" d-flex align-items-center inter-medium">
                                        <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                                            <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                                        </Tag>
                                    </div>;
                                },
                            },
                            {
                                width: 250,
                                title: "Description",
                                dataIndex: "description",
                                className: "name",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return rowData.description;
                                },
                            },

                            {
                                width: 200,
                                title: "Thumbnail Image",
                                dataIndex: "thumbnailPath",
                                className: "",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return (rowData.thumbnailPath ? <Image className="table-img" src={rowData.thumbnailPath} alt={ALT_THUMBNAIL} /> : "NA");
                                },
                            },

                            {
                                width: 150,
                                title: "Updated By",
                                dataIndex: "updatedBy",
                                className: "name",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return rowData.updatedBy?.name || "Na";
                                },
                            },
                            {
                                width: 150,
                                title: "Created By",
                                dataIndex: "createdBy",
                                className: "name",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return rowData.createdBy?.name || "Na";
                                },
                            },
                            {
                                width: 20,
                                title: "Action",
                                dataIndex: "",
                                fixed: "right",
                                className: "",
                                isCell: true,
                                render: (text, rowData, dataKey) => {
                                    return (
                                        // <div className="d-flex gap-4 justify-content-around">
                                        //     {access.updateAccess && <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />}
                                        //     {access.deleteAccess && <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />}
                                        // </div>
                                        <OptionsDropdown
                                            editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                                            deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                                        />
                                    );
                                },
                            },
                        ]}

                        total={categoryList?.length || 0}
                        loading={this.state.isLoading}
                    />
                </div>
            </section>
        );
    }
}
const mapStateToProps = (state) => ({
    personalizationState: state.PersonalizationState,
});
const mapDispatchToProps = {
    getPersonalizationCategoryApi
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PersonalizationCategory));